export default {
  header: {
    border: {
      side: 'bottom',
      size: 'small',
      color: 'border'
    }
  }
}
